import { Fragment } from 'react';

import useGroupSAAMembers from './UseGroupSAAMembers';

import SAAGroupMembersGrid from '../../../../components/grids/saaGroupMembersGrid/SAAGroupMembersGrid';
import GroupMemberWorkflowModal from '../../../../components/dialogs/groupMemberStatus/GroupMemberWorkflowModal';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import { SAVING_MSG } from '@usas/ui-web/utils/Constants';

const GroupSAAMembers = () => {
  const {
    isLoading,
    isSaving,
    gridData,
    state,
    onAddMemberToGroupClicked,
    onEditGroupMemberClicked,
    onEditGroupMemberStatusClicked,
    onDeleteGroupMemberClicked,
    onDeleteModalConfirmClicked,
    onInviteAlternateClicked,
    onModalCancelClicked
  } = useGroupSAAMembers();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Scholastic All America Group Members</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className='col-xs-12 usas-extra-top-margin'>
          <ActionIntraPageButton onClick={onAddMemberToGroupClicked}>Add Member to Group</ActionIntraPageButton>&nbsp;
          <ActionIntraPageButton onClick={onInviteAlternateClicked}>Invite Alternate</ActionIntraPageButton>
        </div>
      </div>
      <div className='row'>
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <SAAGroupMembersGrid
            gridData={gridData}
            isLoading={isLoading}
            onEditClicked={onEditGroupMemberClicked}
            onEditStatusClicked={onEditGroupMemberStatusClicked}
            onDeleteClicked={onDeleteGroupMemberClicked} />
        </div>
      </div>
      {state.displayWorkflowPopup === true &&
        <GroupMemberWorkflowModal memberObj={state.workflowMemberObj} onCloseModal={onModalCancelClicked} />
      }
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Remove Group Member?'}
        displayPopUp={state.displayDeletePopup === true}
        onModalCanceled={onModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>Member:</b> {state.deleteMemberObj?.firstName} {state.deleteMemberObj?.lastName}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onDeleteModalConfirmClicked}>Remove</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default GroupSAAMembers;